require('./dist/select.js');
module.exports = 'ui.select';



//////////////////
// WEBPACK FOOTER
// ./~/ui-select/index.js
// module id = 190
// module chunks = 14